//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Loader from 'vue-spinner/src/ClipLoader.vue'

export default {
    components: {
        Loader,
    },
    props: {
        loading: { type: Boolean, default: false },
        type: { type: String, default: 'primary' }, // 'primary' | 'outline'
        preventDefault: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },
    methods: {
        onClick(e) {
            if (this.preventDefault) {
                e.preventDefault()
            }

            this.$emit('click', e)
        },
    },
}
